import { Link } from "react-router";

import { PATHS } from "@/app/routes/paths";
import { Button } from "@/shared/components/ui/button";

/**
 * Shown when a signed-in user reaches a screen they hold no `view` grant
 * for — typed straight into the address bar, or bookmarked before an
 * administrator narrowed their access. Distinct from the 404 so the
 * operator knows the screen exists and who to ask, rather than assuming a
 * broken link.
 */
export function ForbiddenPage() {
  return (
    <div className="flex h-[70vh] flex-col items-center justify-center gap-4">
      <p className="text-6xl font-semibold text-slate-300">403</p>
      <p className="text-slate-600">You do not have access to this page.</p>
      <p className="text-sm text-slate-500">
        Ask an administrator to grant you access if you need it.
      </p>
      <Button asChild>
        <Link to={PATHS.dashboard}>Back to Dashboard</Link>
      </Button>
    </div>
  );
}
